import { CustomerModel } from './customer.model';

export class ValidateCustomerAction {
  static readonly type = '[Customer] Validate customer email exists';
  constructor(public email: string) {}
}

export class RegisterCustomerAction {
  static readonly type = '[Customer] Create a new customer to analytics';
  constructor(public payload: CustomerModel) {}
}

export class ClearCustomerAction {
  static readonly type = '[Customer] Clear customer data';
}
